import React from 'react';

const ZbiorowyKomornikAdresat = (props) => {

    const { mieszkaniec, adres } = props;

    return (
        <section
            style={{
                display: 'flex',
                justifyContent: 'right',
                fontSize: '12px',
                margin: '5mm 10mm 0 0',
                fontWeight: "600"
            }}
        >
            <div>
                <span>Sz. P.</span><br/>
                <span>{mieszkaniec.imie_nazwisko}</span><br/>
                <span>{adres}</span><br/>
                <span>66-400 Gorzów Wlkp.</span>
            </div>
        </section>
    )
}

export default ZbiorowyKomornikAdresat;